import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Interceptor to unwrap API responses from {success: true, data: {...}} format
 * to just the data object for easier consumption in components
 */
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Check if response has the wrapped format
          const body = event.body;
          if (body && typeof body === 'object' && 'success' in body && 'data' in body) {
            // If response contains pagination metadata (page, total, totalPages),
            // keep the full object so services can read pagination fields.
            // Only unwrap when 'data' is the sole payload.
            if ('page' in body || 'total' in body || 'totalPages' in body) {
              // Remove the 'success' wrapper but keep everything else
              const { success, ...rest } = body;
              return event.clone({ body: rest });
            }
            // Simple wrapper — unwrap to just data
            return event.clone({ body: body.data });
          }
        }
        return event;
      })
    );
  }
}
